import useChatStore from '@/stores/chat'
import { onBeforeMount, onBeforeUnmount } from 'vue'

export const genUuid = () => {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  const uuid = s.join('')
  return uuid
}
// 对document.hidden做前缀处理
export const getHiddenProp = () => {
  const prefixes = ['webkit', 'moz', 'ms', 'o']
  if ('hidden' in document) return 'hidden'
  for (let i = 0; i < prefixes.length; i++) {
    if (prefixes[i] + 'Hidden' in document) return prefixes[i] + 'Hidden'
  }

  return null
}
// 获取document.visibilityState属性
export const getVisibilityState = () => {
  const prefixes = ['webkit', 'moz', 'ms', 'o']
  if ('visibilityState' in document) return 'visibilityState'
  for (let i = 0; i < prefixes.length; i++) {
    if (prefixes[i] + 'VisibilityState' in document) return prefixes[i] + 'VisibilityState'
  }
  return null
}

export const useOffline = () => {
  const chatStores = useChatStore()
  const onlineFn = function () {
    chatStores.updateOfflineStatus(0)
  }
  const offlineFn = function () {
    chatStores.updateOfflineStatus(1)
  }
  onBeforeMount(() => {
    window.addEventListener('online', onlineFn)
    window.addEventListener('offline', offlineFn)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('online', onlineFn)
    window.removeEventListener('offline', offlineFn)
  })
}
